import { schema, types } from 'papr'

const STATUS = ['pending' as const, 'confirmed' as const]

export const emailSubscriberSchema = schema(
	{
		// Note: the user is null in > 130k cases
		user: types.objectId(),
		email: types.string({ required: true }),
		dateAdded: types.date({ required: true }),
		status: types.enum(STATUS, { required: true }),
		publication: types.objectId({ required: true }),
		lastOpened: types.date(),
		isSuppressed: types.boolean(),
		/**
		 * Whether or not this subscriber was imported (via CSV) rather than created through the usual flow.
		 */
		isImported: types.boolean(),
	},
	{
		defaults: {
			isSuppressed: false,
		},
	},
)

export type EmailSubscriberDocument = (typeof emailSubscriberSchema)[0]
export type EmailSubscriberSchemaOptions = (typeof emailSubscriberSchema)[1]
